'use client';

import { useEffect } from 'react';

import { logger } from '@/lib/logger';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Log the error with our structured logger
        logger.error('Global error boundary triggered', {
            error,
            context: {
                component: 'GlobalErrorBoundary',
                url: typeof window !== 'undefined' ? window.location.href : '',
            },
        });
    }, [error]);

    return (
        <html>
            <body>
                <div className='mx-auto my-4 max-w-sm bg-black p-6 text-white'>
                    <h2 className='flex items-center gap-2 text-xl font-bold'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            className='text-error'
                            width='1.2em'
                            height='1.2em'
                            viewBox='0 0 24 24'>
                            <path
                                fill='currentColor'
                                d='M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467L12.884 2.532zM13 18h-2v-2h2v2zm-2-4V9h2l.001 5H11z'
                            />
                        </svg>
                        Server Error
                    </h2>
                    <p className='mt-3 mb-6 text-sm/5'>
                        The server encountered an error and could not complete your request.
                        {error.digest && (
                            <span className='mt-2 block text-xs text-gray-400'>Error ID: {error.digest}</span>
                        )}
                    </p>
                    <button className='rounded bg-white px-4 py-2 text-sm font-bold text-black' onClick={() => reset()}>
                        Try again
                    </button>
                </div>
            </body>
        </html>
    );
}
